<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Форма 4. Третий лист журнала авторского надзора<br />
      Регистрационный лист посещения объекта членами группы
      авторского надзора
    </div>

    <n-divide v-if="$app.auth.can('projects_author', project.id)" class="table-tools">
      <div></div>
      <n-link :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>
    <n-table :columns="columns" :data="data" :loading="$var('load')" headless>
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">Ф.И.О. (при его наличии)</td>
          <td rowspan="2">Место работы</td>
          <td rowspan="2">Занимаемая должность</td>
          <td rowspan="2">Номер телефона</td>
          <td colspan="2">Дата</td>
        </tr>
        <tr class="header">
          <td>прибытия</td>
          <td>убытия</td>
        </tr>
      </template>
      <template #startedAt="{item}">
        {{ $app.date.format(item.startedAt) }}
      </template>
      <template #endedAt="{item}">
        {{ $app.date.format(item.endedAt) }}
      </template>
    </n-table>

    <page-record-create-four v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreateFour from './CreateFour'
export default {
  name: 'MainChapter4',
  components: { PageRecordCreateFour, },
  props: [ 'project', 'journal', ],
  data: () => ({
    columns: [
      { name: 'author.fullName', title: '', },
      { name: 'author.company.title', title: '', },
      { name: 'author.participation.position', title: '', },
      { name: 'author.phone', title: '', },
      { name: 'startedAt', title: '', },
      { name: 'endedAt', title: '', },
    ],
    data: [],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    }, },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.author.four.get(this.project.id)
        .query({ 'with[author][with][participation]': null, projectId: this.project.id, })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
